module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row container flex-wrap",
    class: _vm.phoneError || _vm.isDuplicate || _vm.isInvalid ? 'container-error' : ''
  }, [_c('div', {
    staticClass: "flex flex-column align-center info"
  }, [_c('div', {
    staticClass: "tl inter f6 fw6"
  }, [_vm._v(_vm._s(_vm.deviceModel))]), _vm._v(" "), _c('div', {
    staticClass: "tl inter f7 silver mt2"
  }, [_vm._v(_vm._s(_vm.planInfo))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticClass: "inter f6 input-reset ba db br2 phone-input ml3 mr3 w-100",
    class: _vm.phoneError || _vm.isDuplicate || _vm.isInvalid || (this.phoneNumber.trim().length !== 14 && this.phoneNumber.trim().length > 0) ? 'error' : 'valid',
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 14,
      "placeholder": "Cell Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneError),
      expression: "phoneError"
    }],
    staticClass: "color-theme f6 position",
    class: _vm.phoneError ? '' : 'invisible'
  }, [_vm._v("\n    This phone number is already used by another account\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDuplicate),
      expression: "isDuplicate"
    }],
    staticClass: "color-theme f6 position",
    class: _vm.isDuplicate ? '' : 'invisible'
  }, [_vm._v("\n    Please enter a unique phone number for every plan\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInvalid),
      expression: "isInvalid"
    }],
    staticClass: "color-theme f6 position",
    class: _vm.isInvalid ? '' : 'invisible'
  }, [_vm._v("\n    Please enter a valid phone number\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a236d95a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/formBox/PhoneForm.vue
// module id = 793
// module chunks = 0